import axios from 'axios'

const FIREBASE_BASE_API = process.env.REACT_APP_FIREBASE_BASE_API
export const login = async (email, password) => {
  const response = await axios.post(`${FIREBASE_BASE_API}/callableAdminPortalLogin`, {
    data: { email, password }
  })
  return response.data
}
